<template>
	<div class="flex-center-cross">
		<c-button size="m" hollow @click="selectProduct">选择商品</c-button>
		<span style="margin-left: 10px; font-size: 13px; color: #666;">已选{{dataValue.length}}件</span>
	</div>
</template>

<script>
	export default {
		props: {
			code: String
		},
		
		data() {
			return {
				dataValue: []
			}
		},
		
		methods: {
			selectProduct() {
				let $vm = this.$parent;
				while ($vm.$options.name != 'unitEdit') {
					$vm = $vm.$parent;
				}
				$vm.selectProduct({
					value: this.dataValue,
					resolve: data => {
						this.dataValue = data;
					}
				});
			},
			
			set(data) {
				this.dataValue = data[this.code] || [];
			},
			
			submit: async function() {
				return {
					[this.code]: this.dataValue
				};
			}
		}
	}
</script>

<style lang="stylus" scoped>
</style>
